import { Component, OnInit } from '@angular/core';
import { AuthenticatedUser } from '../../../models/identity/authenticated-user.model';
import { AccountsService } from '../../../services/identity/accounts.service';
import { CommunityService } from '../../../services/identity/community.service';

interface Profile {
    name: string;
    photoUrl: string;
}

@Component({
    selector: 'app-onboarding-community-members',
    templateUrl: './onboarding-community-members.component.html',
    styleUrls: ['./onboarding-community-members.component.scss'],
})
export class OnboardingCommunityMembersComponent implements OnInit {
    public currentUser: AuthenticatedUser;
    public numberOfCommunityUsers: number;
    public profiles: Profile[] = [
        { name: 'Jean Dupont', photoUrl: 'assets/images/fixtures/profil1.jpg' },
        { name: 'Marie Curie', photoUrl: 'assets/images/fixtures/profil2.jpg' },
        { name: 'Pierre Richard', photoUrl: 'assets/images/fixtures/profil3.jpg' },
        { name: 'Sophie Marceau', photoUrl: 'assets/images/fixtures/profil4.jpg' },
        { name: 'Louis Pasteur', photoUrl: 'assets/images/fixtures/profil5.webp' },
        { name: 'Claudia Cardinale', photoUrl: 'assets/images/fixtures/profil6.jpg' },
        { name: 'Paul Cézanne', photoUrl: 'assets/images/fixtures/profil7.jpg' },
        { name: 'Emilie du Châtelet', photoUrl: 'assets/images/fixtures/profil8.jpg' },
        { name: 'Alain Delon', photoUrl: 'assets/images/fixtures/profil9.jpg' },
        { name: 'Brigitte Bardot', photoUrl: 'assets/images/fixtures/profil10.jpg' },
    ];

    constructor(private readonly accountService: AccountsService, private readonly communityService: CommunityService) {}

    ngOnInit() {
        this.currentUser = this.accountService.currentUser;

        this.communityService.getCommunityMembers(this.currentUser.primaryCommunity.id).subscribe((members) => {
            this.numberOfCommunityUsers = members.length;
        });
    }
}
